<template>
  <span>
      <base-button
      :icon="isIcon"
      size="sm"
      :disabled="isReadOnly || isPartnerAccount"
      :class="isIcon ? 'btn-link' : 'btn_extra_small btn_info white'"
      @click.native="modals.notice = true"
    >
      <slot name="modal-link"></slot>
    </base-button>
    <!-- small modal -->
    <modal
      :show.sync="modals.notice"
      headerClasses="justify-content-center"
      type="notice"
    >
      <div class="container text-center">
        <p>ARE YOU SURE YOU WANT TO IMPORT ALL LINE ITEMS?</p>
        <p v-if="lineItems.length == 0" style="color: red">Please add Line Items in the Line Items module to import.</p>
       
       
      </div>
      <template slot="footer">
        <div class="container alert_footer">
          <base-button
            type="danger"
            class="alert_footer_button btn_extra_small btn_info mr-4"
            @click.native="modals.notice = false"
          >
            Close
          </base-button>
          <base-button
            :disabled="isReadOnly || isPartnerAccount || lineItems.length == 0 "
            type="primary"
            class="alert_footer_button btn_extra_small btn_info"
            @click.native="confirm"
          >
            Confirm
          </base-button>
        </div>
      </template>
    </modal>
  </span>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { BaseButton, Modal } from "@/components";

export default {
  name: "replacement-item-all",
  props: {
    id: {
      type: [Number, String],
      default: 0,
    },
    isIcon: {
      type: Boolean,
      default: false,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modals: {
        notice: false,
      },
      replacementItemsLenght: '',
    };
  },
  components: {
    BaseButton,
    Modal,
  },
  computed: {
    ...mapGetters({
      isPartnerAccount: "authentication/isPartnerAccount",
      lineItems: "lineItem/lineItems",
    }),
  },
  methods: {
    ...mapActions({
      getReplacementItems: "replacementItem/getReplacementItems",
      ImportReplacementItems: "replacementItem/ImportReplacementItems",
      getLineItems: "lineItem/getLineItems",
      getReplacementItemStatus: "replacementItem/getReplacementItemStatus",
    }),
    loaded() {
      this.getLineItems(this.$route.params.id);
    },
    confirm(e) {
      let ctx = this;
      ctx.ImportReplacementItems(ctx.id).then((response) => {
        ctx.getReplacementItems(ctx.$route.params.id);
        ctx.getReplacementItemStatus(ctx.$route.params.id);
        ctx.$emit('refresh-line-items')
        ctx.modals.notice = false;
      });
    },
  },
};
</script>
